/**
 * Abaixo de 768 px o mapa vira esta lista (o desenho continua a um toque, em
 * "Ver mapa"): um cartão por setor cadastrado, na ordem do fluxo, com o número,
 * a etapa que o alimenta e os alertas da sala. Tocar abre a página do setor,
 * como tocar na sala.
 */
import React from "react";

import { alertasDaSala, rotuloDaSala } from "./SalaSvg";
import { ItemSetor, ListaSetores, Selo } from "./styles";

/** `elementos` = os do mapa (já na ordem do fluxo); `resumos` = Map<setorId, …>. */
export default function ListaDeSetores({ elementos, resumos, gargalo, salasApagadas, onAbrir }) {
  return (
    <ListaSetores aria-label="Setores">
      {elementos.map((elemento) => {
        const resumo = resumos.get(elemento.setorId);
        if (!resumo) return null;
        const ehGargalo = gargalo === elemento.setorId;
        const alertas = alertasDaSala(resumo, ehGargalo);
        const numero = resumo.filtrados != null ? resumo.filtrados : resumo.total;
        return (
          <li key={elemento.setorId}>
            <ItemSetor
              type="button"
              data-tom={ehGargalo ? "danger" : "neutral"}
              data-apagado={salasApagadas.has(elemento.setorId) ? "sim" : undefined}
              aria-label={rotuloDaSala(elemento.nome, resumo)}
              onClick={() => onAbrir(elemento.setorId)}
            >
              <span className="nome">{elemento.nome}</span>
              <span className="numero">{numero}</span>
              <span className="etapa">{elemento.etapaRotulo || "Sem etapa da planilha"}</span>
              <span className="alertas">
                {alertas.length
                  ? alertas.map((a) => <Selo key={a.id} $tom={a.tom}>{a.texto}</Selo>)
                  : <span className="calmo">Sem atrasos</span>}
              </span>
            </ItemSetor>
          </li>
        );
      })}
    </ListaSetores>
  );
}
